<template>
    <header class="base-page-header-container">
        <breadcrumb v-if="breadcrumb" :breadcrumb="breadcrumb"></breadcrumb>

        <v-row>
            <v-col cols="12" :md="colMdFirst" class="header-title d-flex justify-center justify-md-start">
                <h1 v-if="$vuetify.breakpoint.mdAndUp" class="title-class text-md-left" :class="titleClass">{{ title }}</h1>
                <h2 v-if="$vuetify.breakpoint.smAndDown" class="title-class text-md-left" :class="titleClass">{{ title }}</h2>
                <p v-if="subtitle" :class="subtitleClass">{{ subtitle }}</p>
                <slot name="under-title"></slot>
            </v-col>
            <v-col v-if="$slots['header-actions']"
                cols="12" :md="colMdSecond" class="header-actions d-flex justify-center justify-md-end pr-sm-10">
                <slot name="header-actions"></slot>
            </v-col>
        </v-row>
    </header>
</template>

<script>
import Breadcrumb from '@components/shared/widgets/pages-header/TheBreadcrumb.vue';

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        titleClass: {
            type: [String, Object, Array]
        },
        subtitle: {
            type: String
        },
        subtitleClass: {
            type: [String, Object, Array]
        },
        breadcrumb: {
            type: Array
        },
        colMdFirst: {
            type: Number,
            default: 6
        },
        colMdSecond: {
            type: Number,
            default: 6
        }
    },
    components: {
        Breadcrumb
    }
};
</script>

<style lang="scss">
.base-page-header-container {
    $my-7: 28px;
    margin-top: $my-7;
    margin-bottom: $my-7;
    .title-class{
        text-align: center;
    }
}
</style>
